import 'bootstrap';
import './Modules/ContrastMode.js'
import './Modules/MobileMenu.js'
import '../../../../RosenheimJetzt.OpenStreetMap/Resources/Private/JavaScript/Leaflet.js'
import '../../../../RosenheimJetzt.OpenStreetMap/Resources/Private/JavaScript/OpenStreetMap.js'
import '../../../../RosenheimJetzt.OpenStreetMap/Resources/Private/JavaScript/RosenheimJetzt.OpenStreetMapMarkers.js'
import '../../../../RosenheimJetzt.OpenStreetMap/Resources/Private/JavaScript/RosenheimJetzt.MarkerImageModal.js'
import '../../../../RosenheimJetzt.Search/Resources/Private/JavaScript/SearchResultAutoUpdate.js'

const initModulesOnLoad = function () {
	new window.RosenheimJetzt.MobileMenu()
	new window.RosenheimJetzt.ContrastMode()
	let searchFormElement = document.querySelector('.js__search__form')
	if (searchFormElement) {
		new window.RosenheimJetzt.SearchResultAutoUpdate(searchFormElement)
	}
}

document.onreadystatechange = function () {
	if (document.readyState === 'complete') {
		initModulesOnLoad()
	}
}
